import * as React from 'react';
import { useTranslation } from 'next-i18next';
import { Cog6ToothIcon } from '@heroicons/react/24/outline';

import { cn, useIsFreemiumUser, useResponsiveBreakPoints } from '@restworld/utils-common';
import { Button, Heading } from '@restworld/ui-ds-base';

export function EmployerFlexibleSlotsCard({
  onManageClick,
  activeSlots,
  inactiveSlots,
}: EmployerFlexibleSlotsCardProps) {
  const { t } = useTranslation('common');
  const { isMobile } = useResponsiveBreakPoints();
  const isFreemiumUser = useIsFreemiumUser();

  return (
    <MainWrapper>
      <div>
        <Heading size={5} weight="semibold" color="neutral">
          {t('number_active_slots', { count: activeSlots })}
        </Heading>
        <Heading size={5} weight="semibold" color="neutral-lightest">
          {t('number_inactive_slots', { count: inactiveSlots })}
        </Heading>
      </div>
      <Button
        StartIcon={isFreemiumUser ? undefined : Cog6ToothIcon}
        variant={isMobile ? 'secondary-restworld' : 'tertiary'}
        size="sm"
        onClick={onManageClick}
      >
        {isFreemiumUser ? t('find_out_more') : t('manage')}
      </Button>
    </MainWrapper>
  );
}
export default EmployerFlexibleSlotsCard;

export interface EmployerFlexibleSlotsCardProps {
  activeSlots?: number;
  inactiveSlots?: number;
  onManageClick?: () => void;
}

const MainWrapper = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <div
    className={cn(
      'border-neutral-40 rounded-xl p-5 w-full flex flex-col justify-between gap-8 flex-1 h-full bg-purple-50 md:bg-neutral-10 md:border',
      className
    )}
    {...props}
  />
);
